import React from 'react';
import { TableRow, TableCell } from '@insurancemenu/imenu-components-lib';
import { FILE_TYPE_TITLES, Step, Upload } from 'types/carrierFileService';
import { normDateToShortAmericanDate } from '@insurancemenu/imenu-components-lib/dist/helpers/dateFormatters';
import { convertTag } from 'global/utils/convertTag';
import clsx from 'clsx';
import { createStyles } from './styles';
import MoreDropdown from '../MoreDropdown';

export interface UploadFilesRowProps {
  fileUpload: Upload;
}
const UploadFilesRow = ({ fileUpload }: UploadFilesRowProps): JSX.Element => {
  const classes = createStyles();

  const { fileName, domainId, step, fileType, uploadDate } = fileUpload;

  return (
    <TableRow className={classes.tableRow}>
      <TableCell className={classes.tableCell}>{fileName}</TableCell>
      <TableCell className={classes.tableCell}>{domainId}</TableCell>
      <TableCell className={classes.tableCell}>
        <div className={clsx(classes.tag, classes[`tagType_${Step[step]}`])}>{convertTag(step)}</div>
      </TableCell>
      <TableCell className={classes.tableCell}>{FILE_TYPE_TITLES[fileType]} </TableCell>
      <TableCell className={classes.tableCell}>{normDateToShortAmericanDate(uploadDate)} </TableCell>
      <TableCell className={classes.tableCell} width="10rem">
        <MoreDropdown fileUpload={fileUpload} view="Links" />
      </TableCell>
      <TableCell className={classes.tableCell} width="10rem">
        <MoreDropdown fileUpload={fileUpload} view="Action" />
      </TableCell>
    </TableRow>
  );
};

export default UploadFilesRow;
